module.exports = __webpack_public_path__ + "assets/Attention.285c9579.svg";